import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FunctionalityItemLink from './components/FunctionalityItemLink';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import GraphQL from '../../GraphQL';

class ReportCentral extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      listFunctionalityGroupByUser: [],
    };
  }

  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(changeLoadingTrue());
    const accessDataQuery =
      '{listFunctionalityGroupByUser (type: "RELA"){id, name, key, listOfFunctionalities{id, name, route, key, reportKey}}}';
    GraphQL(accessDataQuery, {})
      .then((res) => {
        this.setState({
          listFunctionalityGroupByUser: res.listFunctionalityGroupByUser,
        });
        dispatch(changeLoadingFalse());
      })
      .catch((erro) => {
        dispatch(changeLoadingFalse());
        console.error(erro);
      });
  };

  render() {
    const { listFunctionalityGroupByUser } = this.state;
    const { t } = this.props;
    const panelContent = listFunctionalityGroupByUser.map((func) => (
      <div className="masonry-brick" key={func.key}>
        <div className="functionality__column">
          {func.name}
          {func.listOfFunctionalities.map((funcC) =>
            funcC.route ? (
              <FunctionalityItemLink
                title={funcC.name}
                to={`/minime/relatorio/${funcC.name.replace('/', '-')}/${
                  funcC.reportKey
                }`}
                key={funcC.reportKey}
              />
            ) : null
          )}
        </div>
      </div>
    ));

    return (
      <Col md={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('panels.report-central')}</h5>
            </div>
            <div className="masonry-grid">{panelContent}</div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ReportCentral)
);
